import * as styles from './style';
import React from 'react';
import {Flex} from "../Container/Flex";
import {shuffle} from "lodash";

const photos = shuffle([
    'https://vevigocdn.blob.core.windows.net/platform/login1.jpg',
    'https://vevigocdn.blob.core.windows.net/platform/login2.jpg',
    'https://vevigocdn.blob.core.windows.net/platform/login3.jpg',
    'https://vevigocdn.blob.core.windows.net/platform/login4.jpg',
    'https://vevigocdn.blob.core.windows.net/platform/login5.jpg',
    'https://vevigocdn.blob.core.windows.net/platform/login6.jpg',
    'https://vevigocdn.blob.core.windows.net/platform/login7.jpg'
]);

const LoginBackground = () => {
    const [photoIndex, setPhotoIndex] = React.useState(0);
    React.useEffect(() => {
        const rotateInterval = setInterval(() => {
            setPhotoIndex(prevIndex => (prevIndex + 1) % photos.length);
        }, 20 * 1000);
        return () => clearInterval(rotateInterval);
    }, []);
    
    return (
        <styles.AppBackground>
            <Flex col>
                {photos.map(((photo, i) => (
                    <styles.Img key={i} visible={photoIndex === i} src={photo} />
                )))}
            </Flex>
        </styles.AppBackground>
    );
}

export default LoginBackground;